export const data = {
  titles: {
    addPlanList: 'Plan / Add New Plan',
    planType: 'Plan Type',
    planBilling: 'Plan Billing',
    planName: 'Plan Name',
    planPrice: 'Price',
    numberOfPropertyAllowedToList: 'Number of Landlords Allowed to invite',
    planDescription: 'Plan Description',
    landlordList: 'Add Multiple Admins (If this plan is private only)',
    cancel: 'Cancel',
    viewListOfLandlord: 'See the list of Admins',
    modalTitle: 'List of emails who have access to this plan',
    addButtonText: 'Add',
    addAndActivate: 'Add & Activate',
  },
  planBillingType: ['Monthly', 'Annually'],
  planType: ['Public', 'Private'],
  placeholderError: {
    planType: [],
    planBilling: [],
    planName: [
      'Plan Name is Required',
      'Plan Name must have atleast 3 characters',
    ],
    planPrice: [
      'Price is Required',
      'Price must be non-negative, greater than 0, and have at most 2 decimal values',
    ],
    numberOfPropertyAllowedToList:[
      'Number of Property To Lanlords is Required',
      'Number of Property To Landlords must be a number',
    ],
    landlordList: [],
    planDescription: [
      'Plan Description is Required',
      'Plan Description must be at least 3 character long.',
      'Plan Description must be no more than 2500 characters long.',
    ],
  },

  emailList: [
    'marry@email.com',
    'marry@email.com',
    'marry@email.com',
    'marry@email.com',
    'marry@email.com',
    'marry@email.com',
  ],
};
